import Vue from 'vue'
import inViewportDirective from 'vue-in-viewport-directive'

export default ({ route }) => {
  const cms = route.query.cms && JSON.parse(route.query.cms)
  const directive = cms ? {} : inViewportDirective
  Vue.directive('in-viewport', directive)
}
